import React from 'react';

import strings from '../../../Localization/Localization';
import {
  installationTicket,
  terminationTicket,
  technicalTicket,
  technicalGlobalTicket,
  commercialTicket,
  administrativeTicket
} from '../../../MetaData/Route/routes';

import BasicNotification from './BasicNotification';

class TicketEditNyukom extends BasicNotification {

  displayMessage() {
    let path = '#';
    switch (this.props.item._arguments["%ticket_group%"]) {
      case 1:
        path = installationTicket.routes.show.createPath(this.props.item._arguments["%ticket_id%"]);
        break;
      case 2:
        path = terminationTicket.routes.show.createPath(this.props.item._arguments["%ticket_id%"]);
        break;
      case 3:
        path = technicalTicket.routes.show.createPath(this.props.item._arguments["%ticket_id%"]);
        break;
      case 4:
        path = technicalGlobalTicket.routes.show.createPath(this.props.item._arguments["%ticket_id%"]);
        break;
      case 5:
        path = commercialTicket.routes.show.createPath(this.props.item._arguments["%ticket_id%"]);
        break;
      case 6:
        path = administrativeTicket.routes.show.createPath(this.props.item._arguments["%ticket_id%"]);
        break;
      default:
        console.log("Unknown ticket group in notification");
    }
    return (
      <a href={path}>{strings.formatString(strings.common.notification.ticket_edit_nyukom, this.props.item._arguments["%ticket_number%"])}</a>
    )
  }
}

export default TicketEditNyukom;
